import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import YouTubeIcon from "@mui/icons-material/YouTube";
import {
  Grid,
  Box,
  Typography,
  Divider,
  Link,
  IconButton,
} from "@mui/material";
import * as constants from "../../constants";

const AuthFooter = () => {
  return (
    <Box sx={{ borderTop: 1, borderColor: "divider" }}>
      <Grid container>
        <Grid item md={8}>
          <Box sx={{ p: 3, m: 1 }}>
            <Typography gutterBottom>
              <Link href="/authentication/login">Home</Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IEEE_SITEMAP}
                target="_blank"
                rel="noopener noreferrer"
              >
                IEEE Sitemap
              </Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IES_CONTACT}
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Society
              </Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IES_ACCESSIBILITY}
                target="_blank"
                rel="noopener noreferrer"
              >
                Accessibility
              </Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IES_NONDISCRIMINATION_POLICY}
                target="_blank"
                rel="noopener noreferrer"
              >
                Nondiscrimination Policy
              </Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IEEE_ETHICS_REPORTING}
                target="_blank"
                rel="noopener noreferrer"
              >
                IEEE Ethics Reporting
              </Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IEEE_PRIVACY_POLICY}
                target="_blank"
                rel="noopener noreferrer"
              >
                IEEE Privacy Policy
              </Link>
              <Link
                sx={{ ml: 2 }}
                href={constants.IEEE_TERMS}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms
              </Link>
            </Typography>

            <Typography color="textSecondary" variant="body2">
              IEEE Industrial Electronics Society Conferences Community
            </Typography>
          </Box>
        </Grid>

        <Grid item md={4}>
          <Box sx={{ textAlign: "center", p: 3, m: 1 }}>
            <IconButton
              color="primary"
              component="a"
              href={constants.IES_FACEBOOK}
              target="_blank"
              rel="noopener noreferrer"
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              color="primary"
              component="a"
              href={constants.IES_TWITTER}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="primary"
              component="a"
              href={constants.IES_LINKEDIN}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon />
            </IconButton>
            <IconButton
              color="secondary"
              component="a"
              href={constants.IES_YOUTUBE}
              target="_blank"
              rel="noopener noreferrer"
            >
              <YouTubeIcon />
            </IconButton>

            <Typography color="textSecondary" variant="body2">
              Need help? <b>conferences@ieee-ies.org</b>
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Divider />

      <Box
        sx={{
          justifyContent: "center",
          display: "flex",
          p: 3,
        }}
      >
        <Typography
          sx={{ textAlign: "center" }}
          color="textSecondary"
          variant="body2"
        >
          © Copyright 2023 IEEE - All rights reserved. A not-for-profit
          organization, IEEE is the world's largest technical professional
          organization dedicated to advancing technology for the benefit of
          humanity.
        </Typography>
      </Box>
    </Box>
  );
};

export default AuthFooter;
